import React, { FC } from 'react';
import { ArchiveProjectPromptProps } from './ArchiveProjectPromptProps';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';

const ArchiveProjectPrompt: FC<ArchiveProjectPromptProps> = ({
  isVisible,
  onClose,
  onCancel,
  onAccept,
}) => {
  const t = useTranslation();
  return (
    <Modal handleCloseBtn={onClose} visible={isVisible}>
      <Prompt
        aria-label="Accessibility header for a modal"
        className="example-prompt-override"
        header={null}
        titleId={'archive-project-modal-title'}
        footer={
          <ModalFooter>
            <Stack direction={'row'} spacing={2} width={'100%'}>
              <Button
                style={{ marginBottom: 0 }}
                text={t('common.cancel')}
                type="secondary"
                onClick={onCancel}
              />
              <Button
                text={t('projects.archiveProject')}
                type="primary"
                onClick={onAccept}
              />
            </Stack>
          </ModalFooter>
        }
        title={<Stack mt={2}>{t('projects.archiveProject')}</Stack>}
      >
        <p>{t('projects.archiveProjectDescription')}</p>
      </Prompt>
    </Modal>
  );
};

export default ArchiveProjectPrompt;
